export default function EmptyProducts({ onClear }) {
  return (
    <div className="rounded-[2rem] border border-border/60 bg-neutral-100/30 px-6 py-16 text-center">
      <h2 className="text-xl font-semibold tracking-tight">No products found</h2>
      <p className="mx-auto mt-3 max-w-md text-sm leading-6 text-muted-foreground">
        Try removing some filters or searching for another product.
      </p>
      <button
        type="button"
        onClick={onClear}
        className="mt-6 rounded-full bg-foreground px-5 py-2.5 text-sm font-medium text-background"
      >
        Reset Filters
      </button>
    </div>
  );
}